import {
  CashbackIcon,
  MinusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ApplicationFeeStatus,
  AppliedDiscountInfo,
  DiscountInfo,
  FeeStatusItem
} from "shared/types";
import { cx, formatToCurrency } from "shared/utils";
import { Applicant } from "types/application";
import { Check } from "untitledui-js-base";
import { formatTitleFirstWord } from "utils/formatTitle";

const iconMap = {
  paid: <Check size="20" className="stroke-success-600" />,
  refunded: (
    <HugeiconsIcon icon={CashbackIcon} className="text-warning-500" size={20} />
  ),
  unpaid: (
    <HugeiconsIcon
      icon={MinusSignIcon}
      size={20}
      className="text-content-100"
    />
  )
};

export const ApplicationFee = ({
  applicant,
  applicationFee
}: {
  applicant: Applicant;
  applicationFee: FeeStatusItem | undefined;
}) => {
  const appliedDiscountInfo = applicant.discount_info?.discount_applied
    ? (applicant.discount_info as AppliedDiscountInfo & DiscountInfo)
    : null;
  // Prefer fee_status data if it exists, otherwise fallback to applicant
  const applicationFeeStatus = applicationFee
    ? applicationFee.status
    : applicant.application_fee_status;

  return (
    <div className="space-y-2">
      <p className="text-xs font-normal text-content-300">Application fee</p>
      <p className="text-sm font-normal text-content-1000">
        {applicant.application_fee_status !==
        ApplicationFeeStatus.NoApplicationFee ? (
          <div className="flex gap-2 items-center">
            {applicationFeeStatus && iconMap[applicationFeeStatus]}
            <p
              className={cx(
                "font-medium",
                applicationFeeStatus === "unpaid"
                  ? "text-content-200"
                  : "text-content-1000"
              )}
            >
              {formatTitleFirstWord(applicationFeeStatus ?? "")}
            </p>
            <p
              className={
                applicationFeeStatus === "unpaid"
                  ? "text-content-200"
                  : "text-content-300"
              }
            >
              ({/* Unpaid */}
              {applicationFeeStatus === "unpaid" &&
                applicant.application_fee &&
                formatToCurrency(applicant.application_fee)}
              {/* Refunded */}
              {applicationFeeStatus === "refunded" &&
                applicationFee?.refunded_amount &&
                (appliedDiscountInfo ? (
                  <>
                    {`${formatToCurrency(applicationFee.refunded_amount, { minimumFractionDigits: 2 })} of `}
                    <span className="line-through">
                      {formatToCurrency(appliedDiscountInfo.original_amount, {
                        minimumFractionDigits: 2
                      })}
                    </span>{" "}
                    {formatToCurrency(appliedDiscountInfo.final_amount, {
                      minimumFractionDigits: 2
                    })}
                  </>
                ) : (
                  `${formatToCurrency(applicationFee.refunded_amount, { minimumFractionDigits: 2 })} of ${
                    applicant.application_fee &&
                    formatToCurrency(applicant.application_fee, {
                      minimumFractionDigits: 2
                    })
                  }`
                ))}
              {/* Paid (with and without discount)  */}
              {applicationFeeStatus === "paid" &&
                applicant.application_fee &&
                (appliedDiscountInfo ? (
                  <>
                    <span className="line-through">
                      {formatToCurrency(appliedDiscountInfo.original_amount, {
                        minimumFractionDigits: 2
                      })}
                    </span>{" "}
                    {formatToCurrency(appliedDiscountInfo.final_amount, {
                      minimumFractionDigits: 2
                    })}
                  </>
                ) : (
                  formatToCurrency(applicant.application_fee, {
                    minimumFractionDigits: 2
                  })
                ))}
              )
            </p>
          </div>
        ) : (
          "-"
        )}
      </p>
    </div>
  );
};
